import { useLocalStorage } from '@nf/utils-common/hooks';

const localStorageKey = 'coin-promo-completed';
export const useIsCoinPromoCompleted = () => {
	const currentValue = localStorage.getItem(localStorageKey);
	return currentValue !== null && /^true$/i.test(currentValue);
};
export const usePromoShine = () => {
	const [promoShineCompleted, setPromoShineCompleted] = useLocalStorage<boolean>(localStorageKey, false)
	return {
		markPromoShineAsCompleted: (isCompleted: boolean) => {
			if (isCompleted && !promoShineCompleted) {
				setPromoShineCompleted(isCompleted);
			}
		},
		Component: () => {
			return promoShineCompleted ? null : <div className="coin-promo-shine"></div>
		}
	}
};